import People from '@material-ui/icons/People'
import StudentList from './StudentList'

const studentList = {
  list: StudentList,
  icon: People,
}

export default studentList
